<sc-activity-list-item [activity]="activity" [showProjectName]="showProjectName" [condensed]="condensed" [link]="showProjectName && activity.Project ? ['/projects', activity.Project.Id] : null">
    <i scActivityIcon class="fa-sharp fa-solid fa-comment"></i>
    {{ texts.jobsiteCommentedPrefix[language] }}
    @if (showProjectName && activity.Project) { {{ texts.jobsiteCommentedFor[language] }} <strong>{{ activity.Project.Name }} {{ texts.genderSuffix[language] }}</strong> }
    {{ texts.jobsiteCommentedSuffix[language] }}
    <div scActivityBody>
        <p [innerHTML]="activity.Payload?.Body"></p>
    </div>
</sc-activity-list-item>
